<template>
  <div class="wrapper" @click="nav2Chart">
    <div class="header" v-if="data.tailWaterCabinetInfo">
      <div class="status-title" v-if="(powerStatus !== 0)">{{deviceStatusMap[data.tailWaterCabinetInfo.deviceStatus]}}</div>
      <div class="status-title" style="color: #999;" v-if="(powerStatus === 0)">离线</div>
      <div class="status" v-if="(powerStatus !== 0)">{{runningStatusMap[data.tailWaterCabinetInfo.runningStatus]}}</div>
      <div class="status" style="color: #999;" v-if="(powerStatus === 0)">实时运行状态</div>
    </div>
    <div class="content">
      <div class="name">
        <template v-if="data.name === '高锰酸盐'">
          <img src="../images/icon_MnO4- .png" alt="">
        </template>
        <template v-if="data.name === '总氮'">
          <img src="../images/icon_N.png" alt="">
        </template>
        <template v-if="data.name === '总磷'">
          <img src="../images/icon_P.png" alt="">
        </template>
        <template v-if="data.name === 'PH值'">
          <img src="../images/icon_ph.png" alt="">
        </template>
        <template v-if="data.name === '悬浮物'">
          <img src="../images/icon_xuanfuwu.png" alt="">
        </template>
        <div :class="[data.name === '高锰酸盐'? 'direction-reverse' : '']">
          <span>{{data.name}}</span>
          <span :class="[powerStatus === 0? 'off-line': '','start-measurement']" 
            v-if="data.name !== 'PH值' && data.name !== '悬浮物'"
            @click.stop="() => { if(powerStatus === 0) return; throttle(startMeasurement, 3000) }">
            启动测量
          </span>
        </div>
      </div>
      <div class="value">
        <span :style="{color: currentValueColor(data)}" v-if="(powerStatus !== 0)">{{data.currentValue.toFixed(2)}}</span>
        <span style="color: #999" v-if="(powerStatus === 0)">{{data.currentValue.toFixed(2)}}</span>
        <span>{{data.unitTitle}}</span>
      </div>
      <div class="progress-bar-box" v-if="(powerStatus !== 0)">
        <template v-if="data.name === '高锰酸盐' || data.name === '总氮' || data.name === '总磷'">
          <div class="progress-bar" style="background-image: linear-gradient(90deg, #4DFF4D 0%, #FFCF33 72%, #FF3333 100%);"></div>
        </template>
        <template v-if="data.name === 'PH值'">
          <div class="progress-bar" style="background-image: linear-gradient(90deg, #FF3333 0%, #FFCF33 28%, #4DFF4D 50%, #FFCF33 75%, #FF3333 100%);"></div>
        </template>
        <template v-if="data.name === '悬浮物'">
          <div class="progress-bar" style="background-image: linear-gradient(90deg, #4DFF4D 0%, #FFCF33 72%, #FF3333 100%);"></div>
        </template>
        <div class="progress-bar-value">
          <!-- <template v-for="item in progressBarValueMap[data.name]">
            <span :key="item">{{item}}</span>
          </template> -->
          <span>{{data.minLimit}}</span>
          <span>{{data.lowerLimit}}</span>
          <span>{{data.upperLimit}}</span>
          <!-- <span>{{Math.round(data.maxLimit * 0.3)}}</span>
          <span>{{Math.round(data.maxLimit * 0.6)}}</span> -->
          <span>{{data.maxLimit}}</span>
        </div>
      </div>
      <div class="progress-bar-box" v-if="(powerStatus === 0)">
        <div class="progress-bar" style="background: linear-gradient(90deg, #B6B6B6 0%, #CCCCCC 72%, #717171 100%);"></div>
        <div class="progress-bar-value">
          <!-- <template v-for="item in progressBarValueMap[data.name]">
            <span :key="item">{{item}}</span>
          </template> -->
          <span>{{data.minLimit}}</span>
          <span>{{data.lowerLimit}}</span>
          <span>{{data.upperLimit}}</span>
          <!-- <span>{{Math.round(data.maxLimit * 0.3)}}</span>
          <span>{{Math.round(data.maxLimit * 0.6)}}</span> -->
          <span>{{data.maxLimit}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sendTailWaterMeasureCmd } from "@/service/apiData.js"

export default {
  name: 'EquipmentInfo',
  data () {
    return {
      runningStatusMap: {
        0: '待机状态', 1: '初始化', 2: '水样加入', 3: '试剂加入', 4: '试剂加入', 5: '试剂加入',
        6: '正在加热', 7: '正在冷却', 8: '预冲洗', 9: '正在排泄', 11: '正在清洗', 12: '标样加入',
        13: '系统异常', 14: '正在冲洗'
      },
      deviceStatusMap: {
        1: '设备状态', 2: '标样核查', 3: '正在清洗', 4: '正在测量', 5: '手动', 6: '系统异常', 7: '正在标定',
      },
      progressBarValueMap: {
        '高锰酸盐': [0, 15, 25, 30],
        '总氮': [0, 2.5, 5.0, 8.0],
        '总磷': [0, 0.4, 0.8, 1.2],
        'PH值': [0, 6, 9, 14],
        '悬浮物': [0, 45, 90, 135]
      },
      lastExecuted: 0,
    }
  },
  props: ['data', 'powerStatus', 'fishBaseId', 'id'],
  computed: {
    currentValueColor () {
      return function (data) {
        // PH值特殊判断
        if(data.name === 'PH值'){
          if(data.minLimit <= data.currentValue && data.currentValue <= data.lowerLimit) {
            return '#FFB146'
          }else if(data.upperLimit <= data.currentValue && data.currentValue <= data.maxLimit){
            return '#FFB146'
          }else if(data.currentValue > data.maxLimit){
            return 'red'
          }
          return
        }
        if (data.upperLimit <= data.currentValue && data.currentValue <= data.maxLimit) {
          return '#FFB146'
        } else if (data.currentValue > data.maxLimit) {
          return 'red'
        }
      }
    }
  },
  methods: {
    nav2Chart () {
      this.$emit('showChart', {
          fishBaseId: this.fishBaseId,
          id: this.id,
          iotName: this.data.iotName,
          name: this.data.name,
      })
      return
      this.$router.push({ path: '/tailWaterMonitoringChart',
        query: {
          fishBaseId: this.fishBaseId,
          id: this.id,
          iotName: this.data.iotName,
          name: this.data.name,
        } 
      })
    },
    // 启动测量
    async startMeasurement(){
      try{
        const { data } = await sendTailWaterMeasureCmd({
          equipmentId: this.id, // 设备Id
          sensorType: this.data.sensorType, // 传感器类型
        })
        this.$message.success('启动测量成功')
      } catch(e) {
        this.$message.error(e.response.data)
      }
    },
    // 定义节流函数
    throttle(fn, delay) {
      // 获取当前时间
      const now = Date.now()
      // 如果当前时间与上一次执行函数的时间差大于延迟时间，则执行函数
      if (now - this.lastExecuted > delay){
        fn()
        this.lastExecuted = now
      }
    }
  },
  mounted () {
  },
  deleted () {
  }
}
</script>
<style scoped lang="stylus">
.wrapper{
  width: 290px;
  height: 280px;
  background: #FFFFFF;
  box-shadow: 3px 3px 20px 1px rgba(0,7,39,0.16);
  border-radius: 10px;
  border: 2px solid #80BFFF;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  .header{
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #707070;
    .status-title{
      font-size: 16px;
      font-weight: bold;
      color: #FFBB00;
      margin-bottom: 16px;
    }
    .status{
      font-size: 16px;
      font-weight: bold;
      color: #3387FE;
    }
  }
  .content{
    width: 100%;
    flex: 1;
    padding: 5px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    .name{
      width: 100%;
      display: flex;
      align-items: center;
      img{
        width: 96px;
        height: 62px;
        margin-right: 20px;
      }
      div{
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        &.direction-reverse{
          flex-direction: row-reverse !important;
        }
        span{
          font-size: 22px;
          color: #333333;
        }
        .start-measurement{
          font-size: 16px;
          font-weight: 500;
          color: #3387FE;
          text-decoration: underline;
          &.off-line{
            color: #999999;
            cursor: default;
          }
        }
      }
    }
    .value{
      text-align: center;
      span:nth-child(1){
        font-size: 44px;
        font-weight: bold;
        color: #00D53C;
      }
      span:nth-child(2){
        font-size: 20px;
        font-weight: 400;
        color: #333333;
      }
    }
    .progress-bar-box{
      width: 230px;
      .progress-bar{
        width: 100%;
        height: 28px;
        border-radius: 18px;
      }
      .progress-bar-value{
        margin-top: 5px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
      }
    }
  }
}
</style>
